
/**
 * Base Interface representing the filter options
 */
export interface IClientAdhesionFilter {
  invoicingService: string;
  dire: string,
  status: string;
}

export let emptyClientAdhesionFilter: IClientAdhesionFilter = {
  invoicingService: '',
  dire: '',
  status: '',
};




// WEBPACK FOOTER //
// ./src/app/model/client-adhesion-filter.ts